"use client"

import { useMemo, useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"
import { StockTable } from "@/components/stocks/StockTable"
import { getStocks } from "@/lib/api/stocks"
import { getWatchlistCodes } from "@/lib/api/watchlist"

export default function StocksPage() {
  const [search, setSearch] = useState("")

  const { data: stocks = [], isLoading } = useQuery({
    queryKey: ["stocks"],
    queryFn: getStocks,
  })

  const { data: watchlist = [] } = useQuery({
    queryKey: ["watchlist", "codes"],
    queryFn: getWatchlistCodes,
  })
  const watchlistCodes = useMemo(() => new Set(watchlist.map((w) => w.stockCode)), [watchlist])

  const filtered = search.trim()
    ? stocks.filter(
        (s) =>
          s.stockName.includes(search.trim()) ||
          s.stockCode.includes(search.trim())
      )
    : stocks

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-zinc-100">종목 목록</h1>
        <span className="text-sm text-zinc-500">
          {isLoading ? "-" : `${filtered.length}개`}
        </span>
      </div>

      <div className="relative w-72">
        <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
        <Input
          placeholder="종목명 또는 코드 검색"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-8 text-zinc-100 placeholder:text-zinc-400"
        />
      </div>

      <div className="rounded-lg border border-zinc-800 bg-zinc-900">
        <StockTable stocks={filtered} isLoading={isLoading} watchlistCodes={watchlistCodes} />
      </div>
    </div>
  )
}
